import { Companion_getInstanceno8hzdksos3n as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveBoostMutationSelectionsClass;
function SaveBoostMutationSelections() {
  if (SaveBoostMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        SaveBoostMutationSelections_instance = this;
        this.o6s_1 = listOf((new (Builder())('saveBoost', Companion_getInstance().o70_1)).p47(listOf((new (Builder_0())(Companion_getInstance_0().w6p_1)).a48(new (CompiledVariable())('input')).l38())).l38());
      }
    }
    initMetadataForObject($, 'SaveBoostMutationSelections');
    SaveBoostMutationSelectionsClass = $;
  }
  return SaveBoostMutationSelectionsClass;
}
var SaveBoostMutationSelections_instance;
function SaveBoostMutationSelections_getInstance() {
  if (SaveBoostMutationSelections_instance === VOID)
    new (SaveBoostMutationSelections())();
  return SaveBoostMutationSelections_instance;
}
//region block: exports
export {
  SaveBoostMutationSelections_getInstance as SaveBoostMutationSelections_getInstance1r4pxampvw2nr,
};
//endregion

//# sourceMappingURL=SaveBoostMutationSelections.mjs.map
